<template>
  <div class="period-configuration">
    <!-- PERIODO DE RESERVA -->
    <div class="form--row">
      <ReservationPeriod :fluctuationData="fluctuationData" />
    </div>

    <!-- PERIODO DE HOSPEDAGEM -->
    <div class="form--row">
      <HostingPeriod :fluctuationData="fluctuationData" :errors="errors" />
    </div>

    <!-- CHECK-IN E CHECK-OUT FLEXÍVEL -->
    <div class="form--row">
      <FlexibleCheckIn :fluctuationData="fluctuationData" :errors="errors" />
    </div>

    <!-- PERIODO DE BLACKOUT -->
    <div class="form--row">
      <PeriodBlackout :fluctuationData="fluctuationData" />
    </div>
  </div>
</template>

<script>
import ReservationPeriod from './ReservationPeriod'
import HostingPeriod from './HostingPeriod'
import FlexibleCheckIn from './FlexibleCheckIn'
import PeriodBlackout from './PeriodBlackout'

export default {
  name: 'PeriodConfiguration',
  components: {
    ReservationPeriod,
    HostingPeriod,
    FlexibleCheckIn,
    PeriodBlackout
  },
  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 12px;
  }
}
</style>
